// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3u2bY","header":"MessagesList_header__2ZXMA","chat":"MessagesList_chat__1HT8R"};